import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// new Password Redux States
import {
  CAREER_PREVIEW_PROFILE_UPDATE,
  DETAIL_GET_COUNTRY,
  DETAIL_GET_IP_LOCATION,
  DETAIL_GET_STATE,
  DETAIL_SET,
  GET_COUNTRY_AND_STATE,
  SEND_TO_DEVELOPER
} from "./actionTypes";

import {
  detailGetIpBasedLocationError,
  detailGetIpBasedLocationSuccess,
  detailSetCountryError,
  detailSetCountrySuccess,
  detailSetError,
  detailSetStateError,
  detailSetStateSuccess,
  detailSetSuccess,
  getCountryAndStateFailure,
  getCountryAndStateSuccess,
  sendtoDeveloperFailure,
  sendtoDeveloperSuccess,
  updateCareerProfilePreviewFailure,
  updateCareerProfilePreviewSuccess
} from "./actions";
//Include Both Helper File with needed methods

import {
  getAllCounties,
  getIpLocation,
  postDetailSet,
  putCall
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* setDetail({ payload: { user, history } }) {
  try {
    
    let response;


    response = yield call(putCall, constClass.REST_API_DETAIL_SET, user);



    let data = JSON.parse(localStorage.getItem("authUser"));
    localStorage.setItem(
      "authUser",
      JSON.stringify({ ...data, profileUpdated: true })
    );

    yield put(detailSetSuccess({ ...data, profileUpdated: true }));

  } catch (error) {
    yield put(detailSetError(error));
  }
}
function* getCountries() {
  try {
    var url = constClass.REST_API_GET_COUNTRIES;

    const response = yield call(getAllCounties, url);

    yield put(detailSetCountrySuccess(response));
  } catch (error) {
    yield put(detailSetCountryError(error));
  }
}

function* getState({ payload: { states } }) {
  try {
    var url = constClass.REST_API_GET_STATE + states;

    const response = yield call(getAllCounties, url);

    yield put(detailSetStateSuccess(response));
  } catch (error) {
    yield put(detailSetStateError(error));
  }
}

function* getIplocation() {
  try {
    var url = constClass.REST_API_GET_IP_LOCATION;

    const response = yield call(getIpLocation, url);

    yield put(detailGetIpBasedLocationSuccess(response));
  } catch (error) {
    yield put(detailGetIpBasedLocationError(error));
  }
}

function* getCountryAndStateHandler(city) {
  try {
    var url = constClass.REST_API_GET_COUNTRY_AND_STATE + city.payload;
    const response = yield call(getAllCounties, url);
    yield put(getCountryAndStateSuccess(response));
  } catch (error) {
    yield put(getCountryAndStateFailure(error));
  }
}

function* setCareerProfilePreview(data) {
  try {
    let preview = data.payload.preview;
    let apiUrl = constClass.REST_API_POST_PREVIEW_CAREER_PAGE;
    const response = yield call(postDetailSet, apiUrl, preview);
    yield put(updateCareerProfilePreviewSuccess(response));
  } catch (error) {
    yield put(updateCareerProfilePreviewFailure(error));
  }
}

function* sendtoDeveloperHandler(data) {
  try {
    let developerdata = data.payload;
    let apiUrl = "configuration/careerpage/developer/email";
    const response = yield call(postDetailSet, apiUrl, developerdata);
    yield put(sendtoDeveloperSuccess(response))
  } catch (error) {
    yield put(sendtoDeveloperFailure(error))
  }
}

function* detailSaga() {
  yield takeEvery(DETAIL_SET, setDetail);
  yield takeEvery(DETAIL_GET_COUNTRY, getCountries);
  yield takeEvery(DETAIL_GET_STATE, getState);
  yield takeEvery(DETAIL_GET_IP_LOCATION, getIplocation);
  //yield takeEvery(GET_COUNTRY_BY_IP,getCountryByIpHandler)
  yield takeLatest(GET_COUNTRY_AND_STATE, getCountryAndStateHandler);
  yield takeLatest(CAREER_PREVIEW_PROFILE_UPDATE, setCareerProfilePreview);
  yield takeLatest(SEND_TO_DEVELOPER, sendtoDeveloperHandler);

}

export default detailSaga;
